import { Card, CardBody } from "@/components/admin/card";
import { PageHead } from "@/components/admin/page-head";
import { Tag } from "@/components/admin/tag";
import { useCreditNotes } from "@/lib/finance/finance-hooks";
import { fmtFCFA } from "@/lib/format";

const REASON_LABEL: Record<string, string> = {
	RETURN: "Retour",
	GESTURE: "Geste",
	ERROR: "Erreur",
	CANCELLATION: "Annulation",
};

/** FIN-04 — Avoirs (notes de crédit). */
export function AdminCreditNotesPage() {
	const { data, isLoading } = useCreditNotes();
	const items = data ?? [];

	return (
		<>
			<PageHead
				title="Avoirs (notes de crédit)"
				sub={`${items.length} avoir(s) · numérotation AVO séquentielle`}
			/>
			<Card>
				<CardBody>
					<div className="table-wrap" style={{ margin: 0 }}>
						<table className="table">
							<thead>
								<tr>
									<th>N° avoir</th>
									<th>Facture liée</th>
									<th>Motif</th>
									<th>Émis le</th>
									<th className="right">Total HT</th>
									<th className="right">TVA</th>
									<th className="right">TTC</th>
									<th>Remb.</th>
								</tr>
							</thead>
							<tbody>
								{isLoading && (
									<tr>
										<td
											colSpan={8}
											className="muted"
											style={{ textAlign: "center", padding: 24 }}
										>
											Chargement…
										</td>
									</tr>
								)}
								{!isLoading && items.length === 0 && (
									<tr>
										<td
											colSpan={8}
											className="muted"
											style={{ textAlign: "center", padding: 24 }}
										>
											Aucun avoir.
										</td>
									</tr>
								)}
								{items.map((c) => (
									<tr key={c.id}>
										<td className="mono">
											<strong>{c.creditNoteNo}</strong>
										</td>
										<td className="mono muted" style={{ fontSize: 11 }}>
											{c.invoiceId.slice(0, 8)}…
										</td>
										<td>
											<Tag variant="terra" noDot>
												{REASON_LABEL[c.reason] ?? c.reason}
											</Tag>
										</td>
										<td className="muted" style={{ fontSize: 12 }}>
											{c.issuedAt}
										</td>
										<td className="right tn">{fmtFCFA(c.totalHt)}</td>
										<td className="right tn">{fmtFCFA(c.totalVat)}</td>
										<td className="right tn">
											<strong>{fmtFCFA(c.totalTtc)}</strong>
										</td>
										<td className="muted">{c.refundMethod ?? "—"}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</CardBody>
			</Card>
		</>
	);
}
